import React from 'react';
import Pylon3Board from './Pylon3Board';

const Pylon3LeftLeg = () => {
  return <Pylon3Board legType="left" />;
};

export default Pylon3LeftLeg;
